// Suara Mochi memakai sampel kucing asli (kitten.mp3) — tanpa sintesis, tanpa noise.
const KEY = "kk-mochi-sound";
const SRC = "/assets/sounds/kitten.mp3";
let ctx = null;
let buffer = null;
let loading = null;
let lastPlayAt = 0;
let active = 0;
const MIN_GAP_MS = 140; // anti-berlipat: satu sampel per 140ms, maks 3 bersamaan
const MAX_ACTIVE = 3;

export const soundEnabled = () => localStorage.getItem(KEY) !== "off";
export const setSoundEnabled = (on) => localStorage.setItem(KEY, on ? "on" : "off");

const getCtx = () => {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
};

const load = () => {
  const c = getCtx();
  if (!c || buffer) return Promise.resolve(buffer);
  if (!loading) {
    loading = fetch(SRC).then((r) => r.arrayBuffer()).then((ab) => c.decodeAudioData(ab)).then((b) => { buffer = b; return b; }).catch(() => null);
  }
  return loading;
};
if (typeof window !== "undefined") window.addEventListener("pointerdown", () => { load(); }, { once: true });

// rate = tinggi nada (1 normal), volume 0–1, offset/duration memotong sampel (detik), delay ms
export function meow({ rate = 1, volume = 0.8, offset = 0, duration, delay = 0 } = {}) {
  if (!soundEnabled()) return;
  const c = getCtx(); if (!c) return;
  load().then((buf) => {
    if (!buf) return;
    const now = performance.now() + delay;
    if (now - lastPlayAt < MIN_GAP_MS || active >= MAX_ACTIVE) return;
    lastPlayAt = now; active += 1;
    const t = c.currentTime + delay / 1000;
    const src = c.createBufferSource(); src.buffer = buf; src.playbackRate.value = rate;
    src.onended = () => { active = Math.max(0, active - 1); };
    const g = c.createGain();
    const dur = Math.min(duration || buf.duration, buf.duration - offset);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(Math.max(0.001, volume), t + 0.03);
    g.gain.setValueAtTime(Math.max(0.001, volume), t + Math.max(0.03, dur - 0.12));
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    src.connect(g); g.connect(c.destination);
    src.start(t, offset, dur);
  });
}

// Dengkuran = sampel diputar pelan & rendah (lembut), tanpa noise sintetis
export const purr = ({ volume = 0.35 } = {}) => meow({ rate: 0.6, volume });

export const SFX = {
  tap: () => meow({ rate: 1 + (Math.random() - 0.5) * 0.15, volume: 0.75 }),
  feed: () => { meow({ rate: 1.05, volume: 0.75 }); meow({ rate: 0.9, volume: 0.45, delay: 900 }); },
  play: () => { meow({ rate: 1.15, volume: 0.85 }); meow({ rate: 1.25, volume: 0.7, delay: 700 }); },
  cuddle: () => purr({ volume: 0.4 }),
  sleep: () => purr({ volume: 0.25 }),
  med: () => meow({ rate: 0.85, volume: 0.6 }),
  revive: () => { meow({ rate: 1.1, volume: 0.8 }); meow({ rate: 1.3, volume: 0.8, delay: 600 }); },
  cheek: () => meow({ rate: 1.3, volume: 0.6, duration: 0.9 }),
  call: () => { meow({ rate: 1.1, volume: 0.85 }); meow({ rate: 1.0, volume: 0.7, delay: 800 }); },
  levelup: () => { meow({ rate: 1.15, volume: 0.85 }); meow({ rate: 1.3, volume: 0.85, delay: 550 }); meow({ rate: 1.45, volume: 0.8, delay: 1100 }); },
};
